import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UploadImageResponse } from '../../lib/services/imageService';
import {
  JobListingItem,
  LISTING_ITEM_TYPE,
} from '../../jobs-module/models/listing.model';
import { Job } from '../../jobs-module/models/job.model';

@Component({
  selector: 'mj-listing-item-tools',
  templateUrl: './mj-listing-item-tools.component.html',
  styleUrls: ['./mj-listing-item-tools.component.scss'],
})
export class MjListingItemToolsComponent {
  @Input() listingItem: JobListingItem;
  @Input() textSearch: string;
  @Input() job: Job;
  @Input() ratio: number[];
  @Output() onItemChanged = new EventEmitter<JobListingItem>();
  @Output() onItemScheduledForRemoval = new EventEmitter<JobListingItem>();

  @Output() public imagePickerOpened = new EventEmitter<boolean>();
  @Output() public isColorPickerOn = new EventEmitter<{}>();

  saveReceivedImage(event: UploadImageResponse) {
    if (this.listingItem.type === LISTING_ITEM_TYPE.LISTING_ITEM_HEADER) {
      if (event) {
        this.listingItem.background_image_media_id = event.id;
        this.listingItem.background_image_url = event.image;
        if (this.job) {
          this.job.image_media_id = event.id;
          this.job.image = event.image;
        }
      } else {
        this.listingItem = {
          ...this.listingItem,
        };
      }
    } else if (this.listingItem.type === LISTING_ITEM_TYPE.LISTING_ITEM_IMAGE) {
      if (event) {
        this.listingItem.image_media_id = event.id;
        this.listingItem.image_url = event.image;
      }
    } else if (
      this.listingItem.type === LISTING_ITEM_TYPE.LISTING_ITEM_FREE_TEXT_IMAGE
    ) {
      if (event) {
        this.listingItem.image_media_id = event.id;
        this.listingItem.image_url = event.image;
      }
    }
  }

  canShowRemoveButton() {
    return (
      this.listingItem.type !== LISTING_ITEM_TYPE.LISTING_ITEM_HEADER &&
      this.listingItem.type !== LISTING_ITEM_TYPE.LISTING_ITEM_FOOTER &&
      this.listingItem.type !== LISTING_ITEM_TYPE.LISTING_ITEM_ABOUT_JOB &&
      this.listingItem.type !== LISTING_ITEM_TYPE.LISTING_ITEM_ABOUT_OFFICE &&
      this.listingItem.type !== LISTING_ITEM_TYPE.LISTING_ITEM_JOBS
    );
  }

  canShowCameraButton() {
    return (
      this.listingItem.type !== LISTING_ITEM_TYPE.LISTING_ITEM_FOOTER &&
      this.listingItem.type !== LISTING_ITEM_TYPE.LISTING_ITEM_ABOUT_JOB &&
      this.listingItem.type !== LISTING_ITEM_TYPE.LISTING_ITEM_FREE_TEXT &&
      this.listingItem.type !== LISTING_ITEM_TYPE.LISTING_ITEM_JOBS &&
      this.listingItem.type !== LISTING_ITEM_TYPE.LISTING_ITEM_VIDEO
    );
  }
}
